// NGRX
import {createFeatureSelector, createSelector} from '@ngrx/store';
// Lodash
import {each} from 'lodash';
// CRUD
import {HttpExtenstionsModel, QueryResultsModel} from '../../_base/crud';
// State
import {ScopesState} from '../_reducers/scope.reducers';
import {ScopeModel} from '..';

export const selectScopesState = createFeatureSelector<ScopesState>('scopes');

export const selectScopeById = (scopeId: number) => createSelector(
	selectScopesState,
	scopesState => scopesState.entities[scopeId]
);

export const selectScopesPageLoading = createSelector(
	selectScopesState,
	scopesState => scopesState.listLoading
);

export const selectScopesActionLoading = createSelector(
	selectScopesState,
	scopesState => scopesState.actionsloading
);

export const selectLastCreatedScopeId = createSelector(
	selectScopesState,
	scopesState => scopesState.lastCreatedScopeId
);

export const selectScopesShowInitWaitingMessage = createSelector(
	selectScopesState,
	scopesState => scopesState.showInitWaitingMessage
);

export const selectScopesInStore = createSelector(
	selectScopesState,
	scopesState => {
		const items: ScopeModel[] = [];
		each(scopesState.entities, element => {
			items.push(element);
		});
		const httpExtension = new HttpExtenstionsModel();
		const result: ScopeModel[] = httpExtension.sortArray(items, scopesState.lastQuery.sortField, scopesState.lastQuery.sortOrder);
		return new QueryResultsModel(result, scopesState.totalCount, '');
	}
);
